import { axiosInstance } from 'services/axiosInstance'

import { ILoginPayload, ISendOtpPayload, IOtpConfirmPayload } from '../types/authApiTypes'

const AUTH_API = '/home-loan-be/api/v1/ldp/authentication'

const authenticationServices = {
  login: (payload: ILoginPayload) =>
    axiosInstance.post(`${AUTH_API}/user/login`, null, {
      params: payload,
    }),
  sendOtp: (payload: ISendOtpPayload) => axiosInstance.post(`${AUTH_API}/otp/send`, payload),
  otpConfirm: (payload: IOtpConfirmPayload) =>
    axiosInstance.post(`${AUTH_API}/otp/confirm`, payload),
}

export { authenticationServices }
